import React from 'react';

import { BreadcrumbsList, BreadcrumbsListItem } from './Breadcrumbs.styles';

export const Breadcrumbs = ({ options, onClick }) => {
	return (
		<BreadcrumbsList>
			{options.map(({ label, value }, index) => (
				<BreadcrumbsListItem
					key={value + index}
					isLarge={options.length === 1}
					onClick={
						index === options.length - 1 ? null : () => onClick(value, index)
					}
				>
					{label}
				</BreadcrumbsListItem>
			))}
		</BreadcrumbsList>
	);
};

export default Breadcrumbs;
